// extracted by mini-css-extract-plugin
module.exports = {"TitleWrapper":"WireInfoComponent__TitleWrapper___1fZ5C","MainInfoWrapper":"WireInfoComponent__MainInfoWrapper___3oq7w"};